(() => {
  if (window.decomotosRimColors) return;
  window.decomotosRimColors = true;

  const update = (picker) => {
    const selected = picker.querySelector('.js-option:checked');
    const output = picker.querySelector('.rim-current');
    if (!output) return;
    const label = selected?.labels?.[0];
    const name = label?.querySelector('.opt-label__text')?.textContent.trim() || '';
    if (output.textContent !== name) output.textContent = name;
    picker.dataset.selectedColorId = selected?.dataset.optionValueId || '';
  };

  const initialize = (root) => {
    root.querySelectorAll('.rim-color-picker').forEach((picker) => {
      picker.querySelectorAll('.rim-chip').forEach((label) => {
        label.title = label.querySelector('.opt-label__text')?.textContent.trim() || '';
      });
      update(picker);
    });
  };

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;
    const picker = event.target.closest('.rim-color-picker');
    if (picker) update(picker);
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})();
